<template>
  <div>
    <div>
      <v-row v-if="profiles && profiles.length" class="indexButtons">
        <button @click="decreaseIndex" value="< Prev">
          <v-icon size="16">fas fa-arrow-left</v-icon> Prev
        </button>
        <div class="indexCount">{{ index + 1 }} / {{ profiles.length }}</div>
        <button @click="increaseIndex" value="Next >">
          Next <v-icon size="16">fas fa-arrow-right</v-icon>
        </button>
      </v-row>
      <v-container
        fluid
        class="pa-0 scrollable"
        v-if="profiles && profiles.length"
      >
        <v-row>
          <v-col class="pt-2 pb-0">
            <h2>
              {{ profiles[index].last_name.toUpperCase() }},
              {{ profiles[index].first_name.toUpperCase() }}
            </h2>
          </v-col>
        </v-row>
        <v-row class="profile-info pb-2">
          <div class="ml-3 p-1">
            {{ profiles[index].email_address[0].toLowerCase() }}
          </div>
          <div class="ml-3">
            {{ profiles[index].phone_numbers[0] }}
          </div>
          <div class="ml-3">{{ isVip(profiles[index].is_vip) }}</div>
        </v-row>
        <v-row>
          <h3 class="pull-left ml-2">Travel Plan</h3>
          <v-container class="profile-timeline">
            <v-timeline dense>
              <v-timeline-item
                medium
                v-for="segment in profiles[index].segments"
                :key="segment.segment_id"
              >
                <template v-slot:icon>
                  <img
                    class="white-svg"
                    :src="getIconSrc(segment.segment_type)"
                    style="color: white;"
                  />
                </template>
                <v-card class="hyp-card segment">
                  <TimelineMultiIata
                    v-if="multiIata(segment)"
                    :segment="segment"
                  ></TimelineMultiIata>
                  <TimelineSingleIata
                    v-else
                    :segment="segment"
                  ></TimelineSingleIata>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-container>
        </v-row>
      </v-container>
    </div>
    <Loader v-if="loading" text="" color="black"></Loader>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { MODULE_PREFIX_HOME } from "@/store";
import { getProfiles } from "@/services/isosTravelTracker/travelTracker.service";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export default {
  name: "ProfileDetails",
  data: function () {
    return {
      profiles: [],
      index: 0,
      loading: false,
    };
  },
  components: {
    ...mapGetters({ detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar" }),
    TimelineMultiIata: () =>
      import("@/components/isosTravelTracker/TimelineMultiIata"),
    TimelineSingleIata: () =>
      import("@/components/isosTravelTracker/TimelineSingleIata"),
    Loader: () => import("@/components/common/Loader"),
  },
  methods: {
    closeParent: function () {
      this.$emit("close-parent");
    },
    decreaseIndex: function () {
      if (this.index === 0) {
        this.index = this.profiles.length - 1;
      } else {
        this.index--;
      }
    },
    increaseIndex: function () {
      if (this.index === this.profiles.length - 1) {
        this.index = 0;
      } else {
        this.index++;
      }
    },
    isVip: function (bool) {
      if (bool) {
        return "Is Vip";
      }
      return "";
    },
    multiIata: function (segment) {
      return segment.fk_to_iata_code !== segment.fk_from_iata_code;
    },
    getIconSrc(type) {
      if (type === "Air") {
        return require(`@/assets/svgs/events_travel_plain.svg`);
      } else if (type === "Car") {
        return require(`@/assets/svgs/vehicle.svg`);
      } else if (type === "Rail") {
        return require(`@/assets/svgs/train.svg`);
      } else if (type === "Hotel") {
        return require(`@/assets/svgs/hotel.svg`);
      }
      return require(`@/assets/svgs/events_travel_plain.svg`);
    },
    filterItineraries() {
      // We don't want to show layover segments on the details panel
      this.profiles.forEach((profile, index, array) => {
        array[index].segments = profile.segments.filter(
          (segment) =>
            segment["segment_type"] != "Layover" &&
            segment["segment_type"] != "Discontinuity"
        );

        profile.segments = profile.segments.sort((a, b) => {
          if (a.from_gmt_date > b.from_gmt_date) return 1;
          else return -1;
        });
      });
    },
  },
  async mounted() {
    this.detailsSidebar = this.$store.state.home.detailsSidebar;
    this.loading = true;
    let segments = this.detailsSidebar.segments;

    let dataParams = {};
    dataParams.profile_ids = [];
    dataParams.itinerary_ids = [];
    segments.forEach((segment) => {
      dataParams.profile_ids.push(segment.profile_id);
      dataParams.itinerary_ids.push(segment.itinerary_id);
    });

    let params = JSON.stringify(dataParams);
    let result = await getProfiles(params);
    if (result) {
      this.profiles = result.data;
      this.filterItineraries();
    } else {
      this.profiles = null;
    }

    this.loading = false;
  },
};
</script>

<style scoped lang="scss">
.row {
  margin-left: 0px;
}

.indexButtons {
  width: 95%;
  margin: 0 auto;
}
.indexCount {
  width: 50%;
  margin: 0 auto;
  text-align: center;
}

.scrollable {
  height: 95vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.profile-info div {
  width: 95%;
}

.seg-row {
  margin-left: 0;
  width: 95%;
}

.segment {
  width: 90%;
  margin: 5px auto;
}

/*timeline styling*/
>>> .white-svg {
  filter: invert(100%) sepia(60%) saturate(416%) hue-rotate(4deg)
    brightness(107%) contrast(105%);
}

>>> .profile-timeline .v-timeline--dense .v-timeline-item__body {
  width: 100%;
  max-width: 100%;
}

>>> .profile-timeline .v-timeline-item__divider {
  min-width: 24px;
}

>>> .profile-timeline .theme--light.v-timeline .v-timeline-item__dot {
  background: $primary-color;
}

>>> .v-timeline:before {
  left: 16px !important;
}
</style>
